import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [ "form","password","passwordToggleHide","passwordToggleShow" ];
  static classes = ["hide",'errorm','readonly'];
  static values = {validateurl: String, validateflag: String};

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }
  validateAll(){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const formData = new FormData(this.formTarget);
    const allErrorE = document.getElementById("allError");
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
        }else{
          allErrorE.innerHTML = '';
          allErrorE.classList.add(this.hideClass);
          this.formTarget.submit();
        }
      }
    });
  }

  password_toggle(event){
    const params = event.params;
    let input;
    let showIcon;
    let hideIcon;
    input = this.passwordTarget;
    showIcon = this.passwordToggleShowTarget;
    hideIcon = this.passwordToggleHideTarget;
    //if password hide
    if(showIcon.classList.contains(this.hideClass)){
      input.type = "text";
    }else {
      input.type = "password";
    }
    showIcon.classList.toggle(this.hideClass);
    hideIcon.classList.toggle(this.hideClass);
  }

}
